export default [
    {
        path: '/offers',
        name: 'PageOffersList',
        meta: { title: 'offer.listTitle', roles: ['ADMIN'], permissions: ['offer_view'] },
        component: () => import('@/pages/offers'),
    },
    {
        path: '/offers/create',
        name: 'PageOffersCreate',
        meta: { title: 'offer.createFormTitle', roles: ['ADMIN'], permissions: ['offer_view'] },
        component: () => import('@/pages/offers/create'),
    },
    {
        path: '/offers/:id/edit',
        name: 'PageOffersEdit',
        meta: { title: 'offer.editFormTitle', roles: ['ADMIN'], permissions: ['offer_view'] },
        component: () => import('@/pages/offers/id/edit'),
    },
]
